import React from 'react'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'

interface TeamMemberCardProps {
  name: string
  title: string
  image: {
    asset: {
      gatsbyImageData: IGatsbyImageData
    }
  }
}

const TeamMemberCard: React.FC<TeamMemberCardProps> = ({ name, title, image }) => {
  return (
    <div className="bg-white shadow">
      <div className="h-[250px] overflow-hidden bg-gray-100 relative">
        <GatsbyImage
          image={image.asset.gatsbyImageData}
          alt={name}
          className="w-full h-full"
          imgStyle={{ objectFit: 'cover', objectPosition: 'top' }}
        />
      </div>
      <div className="text-left" style={{ paddingTop: '20px', paddingLeft: '20px', paddingRight: '20px', paddingBottom: '40px' }}>
        <h3 
          className="font-montserrat"
          style={{ 
            color: '#4CC2B8',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '28px',
            marginBottom: '8px'
          }}
        >
          {name}
        </h3>
        <p 
          className="font-montserrat"
          style={{ 
            color: '#404040',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '28px'
          }}
        >
          {title}
        </p>
      </div>
    </div>
  )
}

export default TeamMemberCard